import { useMemo } from "react";
import { useBreakpoint } from "./useBreakpoint";
import { sceneScalarsFor } from "../components/scene/responsive";
import type { SceneScalars } from "../components/scene/responsive";
import { homeScrollLayout, useScrollLayout } from "../components/scene/scrollLayout";

/**
 * Live scene scalars (pages, tScale, tMax, thresholds, cameras…) derived from
 * the measured home-page overlay (DOM is the source of truth — see
 * sceneThresholds.ts) with per-tier cameras/damping. Updates when the
 * breakpoint changes or the overlay is re-measured (CMS content load, resize).
 *
 * Memoised so the returned object keeps a STABLE identity between updates —
 * consumers put `scalars.thresholds`/`scalars.tScale` in effect deps.
 * Works in all three React roots (Canvas, drei's detached <Scroll html> root,
 * app root) because the layout store is a module singleton.
 */
export function useSceneScalars(): SceneScalars {
  const bp = useBreakpoint();
  const layout = useScrollLayout(homeScrollLayout);
  return useMemo(() => sceneScalarsFor(bp, layout), [bp, layout]);
}
